/*
 * 需求管理接口
 * */
import services from "../config/axios";
import base from "./base";

const courseManageAPI = {
    // 获取课程列表
    getCourseList<T>(params: FormData) {
        return services.post(`${base.lk}/Course/GetCourseList`, params);
    },
    //获取一个课程
    getCourseOne<T>(params: FormData) {
        return services.post(`${base.lk}/Course/GetCourseOne`, params);
    },
    //保存课程
    addCourse<T>(params: FormData) {
        return services.post(`${base.lk}/Course/AddCourse`, params);
    },
    //更新课程
    updateCourse<T>(params: FormData) {
        return services.post(`${base.lk}/Course/UpdateCourse`, params);
    },
    //删除课程
    deleteCourse<T>(params: FormData) {
        return services.post(`${base.lk}/Course/DeleteCourse`, params);
    },
    //保存课程报名
    addCourseEnroll<T>(params: FormData) {
        return services.post(`${base.lk}/Course/AddCourseEnroll`, params);
    },
    //更新课程报名
    updateCourseEnroll<T>(params: FormData) {
        return services.post(`${base.lk}/Course/UpdateCourseEnroll`, params);
    },
    // 获取课程报名列表
    getCourseEnrollList<T>(params: FormData) {
        return services.post(`${base.lk}/Course/GetCourseEnrollList`, params);
    },
    //提交课程报名
    submitCourseEnroll<T>(params: FormData) {
        return services.post(`${base.lk}/Course/SubmitCourseEnroll`, params);
    },
    //删除课程报名
    deleteCourseEnroll<T>(params: FormData) {
        return services.post(`${base.lk}/Course/DeleteCourseEnroll`, params);
    },
    //导入课程报名名单
    importCourseEnroll<T>(params: FormData) {
        return services.post(`${base.lk}/Course/ImportCourseEnroll`, params);
    },
    //下载导入模板
    downloadImportTemplate<T>(params: FormData) {
        return services.post(
            `${base.lk}/Course/DownloadImportTemplate`,
            params,
            {
                responseType: "blob",
            }
        );
    },
    //转换需求
    transferXq<T>(params: FormData) {
        return services.post(`${base.lk}/Course/TransferXQ`, params);
    },
    //导入课程签到名单
    importCourseSignIn<T>(params: FormData) {
        return services.post(`${base.lk}/Course/ImportSignIn`, params);
    },
    //获取课程签到列表
    getCourseSignInList<T>(params: FormData) {
        return services.post(`${base.lk}/Course/GetCourseSignInList`, params);
    },
};

export default courseManageAPI;
